import React from 'react';
import { Row, Col } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import program1 from '../../assets/img/program-1.svg';
import program2 from '../../assets/img/program-2.svg';
import program3 from '../../assets/img/program-3.svg';
import './affiliateProgramWidget.scss';

function AffiliateProgramWidget() {
    const { t } = useTranslation();

    return (
        <div className="program-widget-wrapper">
            <Row>
                <Col md={4} xs={12}>
                    <div className="single-affiliate line-shape">
                        <img src={program1} alt="affiliate-icon" />
                        <h4>{t('affiliate-page.program-text-1')}</h4>
                    </div>
                </Col>
                <Col md={4} xs={12}>
                    <div className="single-affiliate line-shape">
                        <img src={program2} alt="affiliate-icon" />
                        <h4>{t('affiliate-page.program-text-2')}</h4>
                    </div>
                </Col>
                <Col md={4} xs={12}>
                    <div className="single-affiliate">
                        <img src={program3} alt="affiliate-icon" />
                        <h4>{t('affiliate-page.program-text-3')}</h4>
                    </div>
                </Col>
            </Row>
        </div>
    );
}

export default AffiliateProgramWidget;
